import React, { useState, useLayoutEffect, useCallback } from 'react';
import client from '../modules/axios';
import Index from '../layout/Index';
import { API } from '../config/path';
import { Helmet } from 'react-helmet-async';
import { Dialog, DialogContent, IconButton, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const App = () => {
  const [topDestinations, setTopDestinations] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [recommendedTours, setRecommendedTours] = useState([]);
  const [meta, setMeta] = useState(null);
  const [topBlogs, setTopBlogs] = useState([]);
  const [homeContent, setHomeContent] = useState([]);
  const [showBanner, setShowBanner] = useState(true);

  const getMeta = useCallback(() => {
    client
      .get(API.SEO_PAGE + '?page_name=home')
      .then((response) => {
        const data = response.data.data;

        setMeta(data);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  const getTopDestinations = useCallback(() => {
    client
      .get(API.TOP_DESTINATION)
      .then((response) => {
        const data = response.data.success;

        setTopDestinations(data);
        // Snackbar.success(response.statusText);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  const getTopRatedTours = useCallback(() => {
    client
      .get(API.TOP_RATED)
      .then((response) => {
        const data = response.data.success;

        setTopRated(data);
        // Snackbar.success(response.statusText);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  const getRecommendedTours = useCallback(() => {
    client
      .get(API.RECOMMENDED_TOURS)
      .then((response) => {
        const data = response.data.success;

        setRecommendedTours(data);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  const getTopBlogs = useCallback(() => {
    client
      .get(`${API.BLOGS}?is_top_article=true`)
      .then((response) => {
        const data = response.data.data;
        // console.log('data', data);

        setTopBlogs(data);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  const getHomeContent = useCallback(() => {
    client
      .get(API.HOME_CONTENT)
      .then((response) => {
        const data = response.data.data;

        setHomeContent(data);
        // Snackbar.success(response.statusText);
      })
      .catch((_error) => {
        // Snackbar.error(error.statusText);
      });
  }, []);

  useLayoutEffect(() => {
    getTopDestinations();
    getTopRatedTours();
    getRecommendedTours();
    getMeta();
    getTopBlogs();
    getHomeContent();
  }, [getTopDestinations, getTopRatedTours, getRecommendedTours, getMeta, getTopBlogs, getHomeContent]);



  // console.log('topDestinations', topDestinations);
  // console.log('topRated', topRated);
  return (
    <div>
      <Dialog
        open={showBanner && !!homeContent?.home_adds}
        onClose={() => setShowBanner(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            overflow: 'hidden',
            borderRadius: 3,
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <IconButton
            onClick={() => setShowBanner(false)}
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              zIndex: 2,
              bgcolor: 'rgba(0,0,0,0.4)',
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(0,0,0,0.6)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <img
            src={homeContent?.home_adds?.image}
            alt={homeContent?.home_adds?.image_title}
            style={{
              width: '100%',
              height: '100%',
              display: 'block',
              objectFit: 'cover',
            }}
          />
        </DialogContent>
      </Dialog>
      {meta && (
        <Helmet>
          <title>{meta.title ?? 'Indoaddict'}</title>
          <meta name="keyword" content={meta.keyword} />
          <meta name="description" content={meta.description} />


          {meta?.type.map((item, i) => {
            if (meta.value === 'title') {
              return <title key={i}>{item.content}</title>;
            }

            if (item.value === 'canonical') {
              return <link key={i} rel="canonical" href={item.content} />;
            }

            return <meta key={i} {...{ [item.tag_type]: item.value }} content={item.content} />;
          })}
        </Helmet>
      )}
      <Index
        topRatedTours={topRated}
        topDestinations={topDestinations}
        recommendedTours={recommendedTours}
        topBlogs={topBlogs}
        homeContent={homeContent}
      />
    </div>
  );
};

export default App;
